module.exports = __webpack_public_path__ + "static/media/logo.f0d589ec.png";